import { useMemo } from 'react';
import { Box } from '@mui/material';
import { useFormik } from 'formik';

import { FProgressBar } from '../../../../../../components/base';
import { useFormReadOnly } from '../../../../../common';
import DischargeCriteriaFields from './DischargeCriteriaFields';
import { useSaveDischargeFieldOnBlur } from '../hooks';
import { mapDischargePageToCriteriaValues } from '../utils';
import { DISCHARGE_CRITERIA_SCHEMA } from '../validationSchema';

import type { DischargeCriteriaSectionProps } from './types';

export default function DischargeCriteriaSection({
  dischargePage,
  disabled,
  isUpdating,
  onUpdate,
}: DischargeCriteriaSectionProps) {
  const readOnly = useFormReadOnly();
  const initialValues = useMemo(
    () => mapDischargePageToCriteriaValues(dischargePage),
    [dischargePage],
  );
  const formik = useFormik({
    initialValues,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: DISCHARGE_CRITERIA_SCHEMA,
    onSubmit: () => undefined,
  });
  const { saveField } = useSaveDischargeFieldOnBlur({ formik, initialValues, onUpdate });

  return (
    <Box component="form" noValidate onSubmit={formik.handleSubmit}>
      {isUpdating ? <FProgressBar /> : null}
      <DischargeCriteriaFields
        disabled={disabled}
        formik={formik}
        readOnly={readOnly}
        saveField={saveField}
      />
    </Box>
  );
}
